export const SIDEMENU = {
	SET_MENU: "SET_MENU",
	SESSION_LOG: "SESSION_LOG",
	SESSION_LOG_END: "SESSION_LOG_END",
};
